import { Action } from '@ngrx/store';

export enum EFormulationActions {
    GetAllFormulationStock = '[Formulation] Get All Formulation Stock',
    GetAllFormulationStockSuccess = '[Formulation] Set All Formulation Stock Success',
    GetAllFormulationStockError = ' Set All Formulation Stock Error',
    GetAllFormulations = '[Formulation] Get All Formulation',
    GetAllFormulationsSuccess = '[Formulation] Set All Formulation Success',
    GetAllFormulationsError = ' Set All Formulation Error',
    GetAllFormulationsByCompanyId = '[Formulation] Get All Formulation By Company ID',
    GetAllFormulationsByCompanyIdSuccess = '[Formulation] Set All Formulation By Company ID Success',
    GetAllFormulationsByCompanyIdError = 'Set All Formulation By Company ID Error',
    AddFormulation = '[Formulation] Get Add Formulation',
    GetAddFormulationSuccess = '[Formulation] Set Add Formulation Success',
    GetAddFormulationError = ' Set Add Formulation Error',
    EditFormulation = '[Formulation] Get Edit Formulation',
    GetEditFormulationSuccess = '[Formulation] Set Edit Formulation Success',
    GetEditFormulationError = ' Set Edit Formulation Error',
    GetInActiveStatus = '[Formulation]  InActive Status',
    GetInActiveStatusSuccess = '[Formulation]  InActive Status Success',
    GetInActiveStatusError = '[Formulation]  InActive Status Error',
    GetActiveStatus = '[Formulation]  Active Status',
    GetActiveStatusSuccess = '[Formulation]  Active Status Success',
    GetActiveStatusError = '[Formulation]  Active Status Error',
    GetFormulationNumber = '[Formulation] Get Formulation Number',
    GetFormulationNumberSuccess = '[Formulation] Set Formulation Number Success',
    GetFormulationNumberError = '[Formulation] Set Formulation Number Error',
    GetFormulaById = '[Formulation] Get Formula Details By Id',
    SetFormulaByIdSuccess = '[Formulation] Set Formula Details By Id Success',
    SetFormulaByIdError = '[Formulation] Set Formula Details By Id Error',
    GetActiveFormulations = '[Formulation] Get Active Formulations',
    GetActiveFormulationsSuccess = '[Formulation] Set Active Formulations Success',
    GetActiveFormulationsError = '[Formulation] Set Active Formulation Error',
    GetMlcsByFormulaId = '[Formulation] Get Mlc By FormulaId',
    GetMlcsByFormulaIdSuccess = '[Formulation] Get Mlc By FormulaId Success',
    GetMlcsByFormulaIdError = '[Formulation] Get Mlc By FormulaId Error',
    GetImportProduct = '[Formulation] Get Import Product',
    GetImportProductSuccess = '[Formulation] Get Import Product Success',
    GetImportProductError = '[Formulation] Get Import Product Error',
    GetParentFormulas = '[Formulation] Get Parent Formulas',
    GetParentFormulasSuccess = '[Formulation] Get Parent Formulas Success',
    GetParentFormulasError = '[Formulation] Get Parent Formulas Error',
    SubEditFormula = '[Formulation] Sub Edit Formula',
    SubEditFormulaSuccess = '[Formulation] Sub Edit Formula Success',
    SubEditFormulaError = '[Formulation] Sub Edit Formula Error',
}


export class GetAllFormulationStock implements Action {
    public readonly type = EFormulationActions.GetAllFormulationStock;
    constructor(public payload: any) {

    }
}
export class GetAllFormulationStockSuccess implements Action {
    public readonly type = EFormulationActions.GetAllFormulationStockSuccess;
    constructor(public payload: any) {
        // console.log(payload)
    }
}
export class GetAllFormulationStockError implements Action {
    public readonly type = EFormulationActions.GetAllFormulationStockError;
    constructor(public payload: any) {}
}
export class GetAllFormulations implements Action {
    public readonly type = EFormulationActions.GetAllFormulations;
    constructor(public payload: any) {

    }
}
export class GetAllFormulationsSuccess implements Action {
    public readonly type = EFormulationActions.GetAllFormulationsSuccess;
    constructor(public payload: any) {
        // console.log(payload)
    }
}
export class GetAllFormulationsError implements Action {
    public readonly type = EFormulationActions.GetAllFormulationsError;
    constructor(public payload: any) {}
}
export class GetAllFormulationsByCompanyId implements Action {
    public readonly type = EFormulationActions.GetAllFormulationsByCompanyId;
    constructor(public payload: any) {
    }
}
export class GetAllFormulationsByCompanyIdSuccess implements Action {
    public readonly type = EFormulationActions.GetAllFormulationsByCompanyIdSuccess;
    constructor(public payload: any) {
        // console.log(payload)
    }
}
export class GetAllFormulationsByCompanyIdError implements Action {
    public readonly type = EFormulationActions.GetAllFormulationsByCompanyIdError;
    constructor(public payload: any) {}
}
export class AddFormulation implements Action {
    public readonly type = EFormulationActions.AddFormulation;
    constructor(public payload: any) {}
}
export class GetAddFormulationSuccess implements Action {
    public readonly type = EFormulationActions.GetAddFormulationSuccess;
    constructor(public payload: any) {}
}
export class GetAddFormulationError implements Action {
    public readonly type = EFormulationActions.GetAddFormulationError;
    constructor(public payload: any) {}
}
export class EditFormulation implements Action {
    public readonly type = EFormulationActions.EditFormulation;
    constructor(public payload: any, public param: any) {}
}
export class GetEditFormulationSuccess implements Action {
    public readonly type = EFormulationActions.GetEditFormulationSuccess;
    constructor(public payload: any) {}
}
export class GetEditFormulationError implements Action {
    public readonly type = EFormulationActions.GetEditFormulationError;
    constructor(public payload: any) {}
}
export class GetInActiveStatus implements Action {
    public readonly type = EFormulationActions.GetInActiveStatus;
    constructor (public payload: any, public param: any){}
}
export class GetInActiveStatusSuccess implements Action {
    public readonly type = EFormulationActions.GetInActiveStatusSuccess;
    constructor (public payload: any){}
}
export class GetInActiveStatusError implements Action {
    public readonly type = EFormulationActions.GetInActiveStatusError;
    constructor (public payload: any){}
}
export class GetActiveStatus implements Action {
    public readonly type = EFormulationActions.GetActiveStatus;
    constructor (public payload: any, public param: any){}
}
export class GetActiveStatusSuccess implements Action {
    public readonly type = EFormulationActions.GetActiveStatusSuccess;
    constructor (public payload: any){}
}
export class GetActiveStatusError implements Action {
    public readonly type = EFormulationActions.GetActiveStatusError;
    constructor (public payload: any){}
}
export class GetFormulationNumber implements Action {
    public readonly type = EFormulationActions.GetFormulationNumber;
    constructor (public payload: any){}
}
export class GetFormulationNumberSuccess implements Action {
    public readonly type = EFormulationActions.GetFormulationNumberSuccess;
    constructor (public payload: any){}
}
export class GetFormulationNumberError implements Action {
    public readonly type = EFormulationActions.GetFormulationNumberError;
    constructor (public payload: any){}
}
export class GetFormulaById implements Action {
    public readonly type = EFormulationActions.GetFormulaById;
    constructor(public payload : any) {}
}
export class SetFormulaByIdSuccess implements Action {
    public readonly type = EFormulationActions.SetFormulaByIdSuccess;
    constructor(public payload : any) {}
}
export class SetFormulaByIdError implements Action {
    public readonly type = EFormulationActions.SetFormulaByIdError;
    constructor(public payload : any) {}
}
export class GetActiveFormulations implements Action {
    public readonly type = EFormulationActions.GetActiveFormulations;
    constructor(public payload : any) {}
}
export class GetActiveFormulationsSuccess implements Action {
    public readonly type = EFormulationActions.GetActiveFormulationsSuccess;
    constructor(public payload : any) {}
}
export class GetActiveFormulationsError implements Action {
    public readonly type = EFormulationActions.GetActiveFormulationsError;
    constructor(public payload : any) {}
}
export class GetMlcsByFormulaId implements Action {
    public readonly type = EFormulationActions.GetMlcsByFormulaId;
    constructor(public payload : any) {}
}
export class GetMlcsByFormulaIdSuccess implements Action {
    public readonly type = EFormulationActions.GetMlcsByFormulaIdSuccess;
    constructor(public payload : any) {}
}
export class GetMlcsByFormulaIdError implements Action {
    public readonly type = EFormulationActions.GetMlcsByFormulaIdError;
    constructor(public payload : any) {}
}
export class GetImportProduct implements Action {
    public readonly type = EFormulationActions.GetImportProduct;
    constructor(public payload : any) {}
}
export class GetImportProductSuccess implements Action {
    public readonly type = EFormulationActions.GetImportProductSuccess;
    constructor(public payload : any) {}
}
export class GetImportProductError implements Action {
    public readonly type = EFormulationActions.GetImportProductError;
    constructor(public payload : any) {}
}
export class GetParentFormulas implements Action {
    public readonly type = EFormulationActions.GetParentFormulas;
    constructor(public payload: any) {}
}
export class GetParentFormulasSuccess implements Action {
    public readonly type = EFormulationActions.GetParentFormulasSuccess;
    constructor(public payload: any) {}
}
export class GetParentFormulasError implements Action {
    public readonly type = EFormulationActions.GetParentFormulasError;
    constructor(public payload: any) {}
}

export class SubEditFormula implements Action {
    public readonly type = EFormulationActions.SubEditFormula;
    constructor(public payload: any) {}
}
export class SubEditFormulaSuccess implements Action {
    public readonly type = EFormulationActions.SubEditFormulaSuccess;
    constructor(public payload: any) {}
}
export class SubEditFormulaError implements Action {
    public readonly type = EFormulationActions.SubEditFormulaError;
    constructor(public payload: any) {}
}

export type FormulationAction = GetAllFormulationStock | GetAllFormulationStockSuccess | GetAllFormulationStockError | 
                                    GetAllFormulations | GetAllFormulationsSuccess | GetAllFormulationsError |
                                    GetAllFormulationsByCompanyId | GetAllFormulationsByCompanyIdSuccess | GetAllFormulationsByCompanyIdError |
                                    AddFormulation | GetAddFormulationSuccess | GetAddFormulationError |
                                    EditFormulation | GetEditFormulationSuccess | GetEditFormulationError |GetActiveStatus | GetActiveStatusSuccess|GetActiveStatusError
                                    |GetInActiveStatus | GetInActiveStatusSuccess|GetInActiveStatusError| GetFormulationNumber |GetFormulationNumberSuccess|
                                    GetFormulationNumberError | GetFormulaById | SetFormulaByIdSuccess | SetFormulaByIdError | GetActiveFormulations |
                                    GetActiveFormulationsSuccess | GetActiveFormulationsError|
                                    GetMlcsByFormulaId|GetMlcsByFormulaIdSuccess|GetMlcsByFormulaIdError |GetImportProduct|GetImportProductSuccess| GetImportProductError |
                                    GetParentFormulas | GetParentFormulasSuccess| GetParentFormulasError |
                                    SubEditFormula | SubEditFormulaSuccess | SubEditFormulaError;
